import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface KarteProps {
  titel?: ReactNode;
  beschreibung?: ReactNode;
  aktionen?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** Als Fläche ohne eigenen Rahmen, z. B. innerhalb einer Liste. */
  flach?: boolean;
}

export const Karte = ({
  titel,
  beschreibung,
  aktionen,
  children,
  className,
  flach,
}: KarteProps) => (
  <section
    className={cn(
      'rounded-xl bg-white dunkel:bg-slate-900',
      !flach && 'shadow-sm ring-1 ring-slate-200 dunkel:ring-slate-700',
      className,
    )}
  >
    {(titel || aktionen || beschreibung) && (
      <header className="flex flex-wrap items-start justify-between gap-3 border-b border-slate-200 px-4 py-3 dunkel:border-slate-700">
        <div className="min-w-0">
          {titel && (
            <h2 className="text-base font-semibold text-slate-900 dunkel:text-slate-100">
              {titel}
            </h2>
          )}
          {beschreibung && (
            <p className="mt-0.5 text-sm text-slate-500 dunkel:text-slate-400">{beschreibung}</p>
          )}
        </div>
        {aktionen && <div className="flex shrink-0 items-center gap-2">{aktionen}</div>}
      </header>
    )}
    <div className="p-4">{children}</div>
  </section>
);
